export function readServerValue<T = unknown>(id = "app-props", parseJson = true, fallback?: T): T {
    const el = document.getElementById(id);
    const raw = el?.textContent?.trim();

    if (!raw) {
        if (fallback !== undefined) return fallback;
        throw new Error(`Missing server JSON: <script id="${id}" type="application/json">...`);
    }

    if (!parseJson) return raw as unknown as T;

    try {
        return JSON.parse(raw) as T;
    } catch (e) {
        if (fallback !== undefined) return fallback;
        throw new Error(`Invalid JSON in #${id}: ${(e as Error).message}`);
    }
}
